import { render } from "./InputSwitchButtonCustom.vue?vue&type=template&id=d1728916&scoped=true"
import script from "./InputSwitchButtonCustom.vue?vue&type=script&lang=js"
export * from "./InputSwitchButtonCustom.vue?vue&type=script&lang=js"

import "./InputSwitchButtonCustom.vue?vue&type=style&index=0&id=d1728916&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1728916"]])

export default __exports__